import { jsxs as c, jsx as t, Fragment as y } from "react/jsx-runtime";
import { useRef as u, useState as W, useEffect as E, useCallback as f, useMemo as F } from "react";
import { ArrowUpSmallFillIcon as j, ArrowDownSmallFillIcon as U } from "@ifrc-go/icons";
import { _ as m } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import z from "../Button/index.js";
import G from "../Popup/index.js";
import H from "../../contexts/dropdown-menu.js";
import J from "../../hooks/useBlurEffect.js";
import '../../index23.css';const K = "_dropdown-menu_sooqs_1", L = "_dropdown-icon_sooqs_8", O = "_dropdown-content_sooqs_14", Q = "_without-padding_sooqs_19", n = {
  dropdownMenu: K,
  dropdownIcon: L,
  dropdownContent: O,
  withoutPadding: Q
};
function ro(w) {
  const h = u(null), {
    className: _,
    activeClassName: b,
    children: g,
    label: C,
    labelBefore: P,
    labelAfter: a,
    labelSpacing: I,
    labelColorVariant: R,
    labelStyleVariant: M,
    labelWithoutPadding: N,
    labelWithoutAdditionalInlinePadding: A,
    withoutDropdownIcon: i,
    componentRef: r,
    elementRef: d = h,
    persistent: s,
    popupClassName: D,
    preferredPopupWidth: S,
    withoutPopupPadding: v
  } = w, p = u(null), [e, o] = W(!1);
  E(() => {
    r && (r.current = {
      setShowDropdown: o
    });
  }, [r, o]);
  const x = f(
    () => {
      o((l) => !l);
    },
    [o]
  ), B = f(
    (l, q) => {
      q || l && s || o(!1);
    },
    [o, s]
  );
  J(
    e,
    B,
    p,
    d
  );
  const V = F(
    () => ({
      setShowDropdown: o
    }),
    [o]
  ), k = !!a || !i;
  return /* @__PURE__ */ c(H.Provider, { value: V, children: [
    /* @__PURE__ */ t(
      z,
      {
        name: void 0,
        className: m(
          n.dropdownMenu,
          e && b,
          _
        ),
        layoutElementRef: d,
        onClick: x,
        styleVariant: M,
        colorVariant: R,
        withoutPadding: N,
        spacing: I,
        after: k ? /* @__PURE__ */ c(y, { children: [
          a,
          !i && (e ? /* @__PURE__ */ t(j, { className: n.dropdownIcon }) : /* @__PURE__ */ t(U, { className: n.dropdownIcon }))
        ] }) : void 0,
        before: P,
        withoutAdditionalInlinePadding: A,
        children: C
      }
    ),
    e && /* @__PURE__ */ t(
      G,
      {
        elementRef: p,
        className: m(
          n.dropdownContent,
          v && n.withoutPadding,
          D
        ),
        parentRef: d,
        preferredWidth: S,
        children: g
      }
    )
  ] });
}
export {
  ro as default
};
